import { useState } from 'react';
import { PhotoBtn } from '../../components/PhotoBtn.jsx';
import { tr } from '../../lib/i18n';
import { prepareTampon } from '../../lib/tampon';
import { C } from '../../theme/palette';

/**
 * Importer le tampon de la société : un PDF, une image, ou une photo du tampon
 * sur une feuille blanche.
 *
 * <p>Seule une photo était acceptée, gardée en JPEG sur fond blanc : un tampon
 * reçu en PDF ne pouvait pas être joint, et posé sur un document il en
 * cachait le texte d'un rectangle blanc. Le fond devient transparent et
 * l'image est recadrée sur l'encre.
 *
 * @param {object} props propriétés
 * @param {(tampon: string) => void} props.onTampon reçoit le tampon en PNG transparent
 * @param {boolean} [props.change] un tampon existe déjà
 * @returns {import('react').ReactElement} les deux boutons
 */
export function TamponImport({ onTampon, change }) {
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState('');

  const prepare = async (source) => {
    setEnCours(true);
    setErreur('');
    try {
      onTampon(await prepareTampon(source));
    } catch (e) {
      setErreur(e?.message || tr('Ce fichier n’a pas pu être lu.'));
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div>
      <label
        style={{
          display: 'block',
          textAlign: 'center',
          cursor: 'pointer',
          background: C.teal,
          color: '#fff',
          borderRadius: 10,
          padding: '11px 8px',
          fontSize: 12,
          fontWeight: 800,
          marginBottom: 6,
        }}
      >
        {enCours
          ? tr('⏳ Préparation du tampon…')
          : change
            ? tr('📎 Changer le tampon (PDF ou image)')
            : tr('📎 Joindre le tampon (PDF ou image)')}
        <input
          type="file"
          accept="application/pdf,image/*"
          disabled={enCours}
          style={{ display: 'none' }}
          onChange={(e) => {
            const f = e.target.files && e.target.files[0];
            e.target.value = '';
            if (f) prepare(f);
          }}
        />
      </label>
      <PhotoBtn label="📷 Photographier le tampon" color={C.teal} full onPhoto={prepare} />
      <div style={{ fontSize: 9, color: C.muted, marginTop: 5, lineHeight: 1.45 }}>
        {tr(
          'Le blanc autour du tampon est enlevé : il se pose sur les documents sans cacher le texte.',
        )}
      </div>
      {erreur && (
        <div role="alert" style={{ color: C.red, fontSize: 10.5, fontWeight: 700, marginTop: 5 }}>
          ✕ {erreur}
        </div>
      )}
    </div>
  );
}
